import TrainingModule from "./TrainingModule";

export default TrainingModule;
